import React from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { Link, useLocation } from "react-router-dom"
import arrow from "../../assets/icons/arrow.svg"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import cardIon1 from "../../assets/icons/Group-card-1.png"
import cardIon2 from "../../assets/icons/Group-card-2.png"
import cardIon3 from "../../assets/icons/Group-card-3.png"
import cardIon4 from "../../assets/icons/Group-card-4.png"
import DotIcon from "../Finance/voucherEntry/dotsvg"
import RenderSubmenu from "../../components/Common/renderMenu"
const Procurement = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Procurement${companyname ? ` | ${companyname}` : ''}`;

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const location = useLocation();

  const menuItem = loggedUser?.smenu?.find(
    item => item.linkTo === `${location?.pathname}`
  )

  const cardData = [
    { name: "Total Suppliers", amount: "1000", icon: cardIon1 },
    { name: "Total  Purchase Orders", amount: "2000", icon: cardIon2 },
    { name: "Total  Material Requests", amount: "3000", icon: cardIon3 },
    { name: "Total  GRNs", amount: "4000", icon: cardIon4 },
  ]

  return (
    <div className="page-content page-content-index">
      <Container fluid className="">
        <Card className="invoice-main-card">
          <Row className="mt-3 mx-1 mb-0">
            {cardData?.length &&
              cardData.map((ele, key) => (
                <Col md={3} xl={3} sm={4} xs={12} key={key}>
                  <Card className="rounded-0 border-0 invoice-card">
                    <CardBody className={`card-body-${key}`}>
                      <Row>
                        <Col lg={"auto"}>
                          <img src={ele?.icon} />
                        </Col>
                        <Col lg={"auto"} className="d-flex justify-content-center flex-column">
                          <div className={`pb-1 fw-500 card-body-head-${key}`}>
                            {ele?.name}
                          </div>
                          <div className={`fw-500 card-body-amt-${key}`}>
                            {ele?.amount}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              ))}
          </Row>
          <hr />
          <Row className="mt-4 mx-1 mb-3">
          {menuItem?.submenus?.map((item, index) => (
              <Col lg={3} sm={4} xs={12} key={item?.id || index}>
                <RenderSubmenu item={item} />
              </Col>
            ))}
            {/* <Col lg={4} sm={6} xs={12}>
              <div className="sub-menu-title mb-3">Masters</div>
              <Row>
                <Col xs={12}>
                  {menuItem?.submenus?.map(dt => (
                    <>
                      {loggedUser?.permission?.some(
                        permissionItem =>
                          permissionItem?.id === dt.id &&
                          permissionItem?.is_menu == 1 &&
                          permissionItem?.tagline == "Your Shortcuts"
                      ) && (
                        <Link to={dt?.linkTo}>
                          <div className="mb-1">
                          <span className="list-of-dashmenus"><DotIcon /></span>&nbsp;&nbsp;&nbsp;
                            <label className="sub-menu-link" role="button">
                              {dt?.label}
                            </label>
                            <img src={arrow} alt="" width="7" />
                          </div>
                        </Link>
                      )}
                    </>
                  ))}
                </Col>
              </Row>
            </Col>
            <Col lg={4} sm={6} xs={12}>
              <div className="sub-menu-title mb-3">Stock Management</div>
              <Row>
                <Col xs={12}>
                  {menuItem?.submenus?.map(dt => (
                    <>
                      {loggedUser?.permission?.some(
                        permissionItem =>
                          permissionItem?.id === dt.id &&
                          permissionItem?.is_menu == 1 &&
                          permissionItem?.tagline == "Stock Management"
                      ) && (
                        <Link to={dt?.linkTo}>
                          <div className="mb-1">
                          <span className="list-of-dashmenus"><DotIcon /></span>&nbsp;&nbsp;&nbsp;
                            <label className="sub-menu-link" role="button">
                              {dt?.label}
                            </label>
                            <img src={arrow} alt="" width="7" />
                          </div>
                        </Link>
                      )}
                    </>
                  ))}
                </Col>
              </Row>
            </Col>
            <Col lg={4} sm={6} xs={12}>
              <div className="sub-menu-title mb-3">Reports</div>
              <Row>
                <Col lg={4} sm={6} xs={12}>
                  {menuItem?.submenus?.map(dt => (
                    <>
                      {loggedUser?.permission?.some(
                        permissionItem =>
                          permissionItem?.id === dt.id &&
                          permissionItem?.is_menu == 1 &&
                          permissionItem?.tagline == "Reports"
                      ) && (
                        <Link to={dt?.linkTo}>
                          <div className="mb-1">
                          <span className="list-of-dashmenus"><DotIcon /></span>&nbsp;&nbsp;&nbsp;
                            <label className="sub-menu-link" role="button">
                              {dt?.label}
                            </label>
                            <img src={arrow} alt="" width="7" />
                          </div>
                        </Link>
                      )}
                    </>
                  ))}
                </Col>
              </Row>
            </Col> */}
          </Row>
        </Card>
      </Container>
    </div>
  )
}

export default Procurement
